import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../lib/theme';
import { MoonIcon, SunIcon } from './Icons';

function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const options = [
    { value: 'light' as const, label: 'Light mode', Icon: SunIcon },
    { value: 'dark' as const, label: 'Dark mode', Icon: MoonIcon },
  ];
  return (
    <div role="radiogroup" aria-label="Colour theme" className={`theme-toggle${theme === 'dark' ? ' dark' : ''}`}>
      <span className="knob" aria-hidden="true" />
      {options.map(({ value, label, Icon }) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={theme === value}
          aria-label={label}
          title={label}
          onClick={() => setTheme(value)}
          onMouseDown={e => e.preventDefault()} // keep focus on the typing test
        >
          <Icon size={14} />
        </button>
      ))}
    </div>
  );
}

export function Brand({ link = true }: { link?: boolean }) {
  const content = (
    <>
      <img src="/logo.svg" alt="" />
      <span>TypeRV</span>
    </>
  );
  return link ? (
    <Link to="/" className="brand" aria-label="TypeRV home">
      {content}
    </Link>
  ) : (
    <span className="brand">{content}</span>
  );
}

interface ShellProps {
  children: React.ReactNode;
  /** Small logo and name at the top left (the code entry page shows a large one instead) */
  header?: boolean;
  /** Make the header logo a link home (off during the real test) */
  brandLink?: boolean;
}

export function Shell({ children, header = true, brandLink = true }: ShellProps) {
  return (
    <div className="shell">
      {header && (
        <header className="shell-header">
          <Brand link={brandLink} />
        </header>
      )}
      <main className="shell-main">{children}</main>
      <footer className="shell-footer">
        <span>© {new Date().getFullYear()} TypeRV</span>
        <ThemeToggle />
      </footer>
    </div>
  );
}
